module.exports = __webpack_public_path__ + "rosacea_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_3_after.jpg
// module id = 981
// module chunks = 0